const promiseConstructor = Promise as PromiseConstructor & {
  try?: (
    callbackfn: (...args: unknown[]) => unknown,
    ...args: unknown[]
  ) => Promise<unknown>;
};

if (typeof promiseConstructor.try !== 'function') {
  promiseConstructor.try = (callbackfn, ...args) => new Promise(resolve => {
    resolve(callbackfn(...args));
  });
}
